var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('headerContainer')],1),_c('el-container',[_c('el-aside',{attrs:{"width":"270px"}},[_c('asideContainer')],1),_c('el-main',[_c('mainContainer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }